import React from 'react';
import '../blocks/ModernBlocks.css';

const TeamShowcaseBlock = ({ data }) => {
  return (
    <section className="team-showcase-section">
      <div className="team-showcase-container">
        <div className="team-showcase-header">
          <h2 className="team-showcase-title">{data.title}</h2>
          <p className="team-showcase-subtitle">{data.subtitle}</p>
        </div>
        
        <div className="team-showcase-grid">
          {data.members.map((member, index) => (
            <div key={index} className="team-member-card">
              <div className="member-image">
                <img src={member.image} alt={member.name} />
                <div className="member-overlay">
                  <div className="member-social">
                    <span className="member-certifications">
                      {member.certifications.length} Certifications
                    </span>
                  </div>
                </div>
              </div>
              
              <div className="member-info">
                <h3 className="member-name">{member.name}</h3>
                <p className="member-position">{member.position}</p>
                
                <div className="member-expertise">
                  <h4>Expertise:</h4>
                  <div className="expertise-tags">
                    {member.expertise.map((skill, skillIndex) => (
                      <span key={skillIndex} className="expertise-tag">{skill}</span>
                    ))}
                  </div>
                </div>
                
                <div className="member-certifications">
                  <h4>Certifications:</h4>
                  <div className="certification-tags">
                    {member.certifications.map((cert, certIndex) => (
                      <span key={certIndex} className="certification-tag">{cert}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamShowcaseBlock; 